import { Contact, Contacts as List } from "@gromia/components/landing/Contacts";
import { useLayoutConfig } from "@gromia/components/useLayoutConfig";
import { useFeatures, whenEnabled } from "@gromia/utils/useFeatures";
import React from "react";

export const Contacts = () => {
  const features = useFeatures();
  const config = useLayoutConfig();

  return (
    <List>
      {whenEnabled(features.global.showPhone, () => (
        <Contact
          t="phone"
          title="Chiamaci al telefono"
          text={config.phoneLandlineLabel}
          href={`tel:${config.phoneLandlineValue}`}
        />
      ))}
      <Contact
        t="chat"
        title="Scrivici tramite WhatsApp"
        text="Chatta ora"
        href={`https://wa.me/${config.whatsappValue}`}
      />
      <Contact
        t="email"
        title="Inviaci una mail"
        text={config.supportEmail}
        href={`mailto://${config.supportEmail}`}
      />
    </List>
  );
};
